import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("title", null, "Group 2", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "Symbols",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      id: "Oval",
      stroke: "var(--primary)",
      "stroke-width": "2",
      cx: "10",
      cy: "10",
      r: "10"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      id: "Oval-Copy",
      fill: "var(--primary)",
      cx: "10",
      cy: "10",
      r: "7"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}